// import React from "react";
// import "./../styles/Navbar.css";
// import logo from "../assets/images/Way2win.png";
// import { useNavigate } from "react-router-dom";
// function Navbar() {
//   const navigate = useNavigate();
//   return (
//     <nav className="navbar">
//       <div className="navbar-logo">
//         <img src={logo} alt="Brand Logo" />
//       </div>
//       <ul className="navbar-links">
//         <li>
//           <a href="#home">Home</a>
//         </li>
//         <li>
//           <a href="#about">About Us</a>
//         </li>
//         <li>
//           <a href="#contact">Contact</a>
//         </li>
//         {/* <li>
//           <a
//             onClick={() => {
//               navigate("/appointment");
//             }}
//           >
//             Appointment
//           </a>
//         </li> */}
//         <li>
//           <button
//             className="login-button"
//             onClick={() => {
//               navigate("/signin");
//             }}
//             style={{
//               background: "black",
//               border: "1pxsolidblack",
//               color: "white",
//               borderRadius: "10px",
//               textDecoration: "none",
//               fontSize: "18px",
//               cursor: "pointer",
//               transition: "color 0.3s",
//             }}
//           >
//             Login
//           </button>
//         </li>
//       </ul>
//     </nav>
//   );
// }

// export default Navbar;

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiArrowUpRight, FiSearch } from "react-icons/fi";
import { HiOutlineMenuAlt3 } from "react-icons/hi";
import logo from "../../assets/images/bjp final.png";
import "../styles/Navbar.css";
import { FaHome, FaUsers, FaInfoCircle, FaPhoneAlt, FaSignOutAlt } from "react-icons/fa";

function Navbar() {

  const [isOpen, setIsOpen] = useState(false);
 const navigate = useNavigate();

 const handleScroll = (id) => {
  setIsOpen(true); // Close menu on click
  const section = document.getElementById(id);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
};

  const menuStyle = {
    position: "absolute",
    top: "50px",
    right: "0",
    background: "#f6f6f5ff",
    boxShadow: "0 5px 10px rgba(0, 0, 0, 0.2)",
    borderRadius: "8px",
    width: "180px",
    zIndex: "1000",
  };
  
  const menuListStyle = {
    listStyle: "none",
    margin: "0",
    padding: "10px 0",
  };
  
  const menuItemStyle = {
    padding: "10px 15px",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    cursor: "pointer",
    fontSize: "16px",
    color: "#333",
    transition: "background 0.3s",
  };
  
  menuItemStyle[":hover"] = {
    background: "#f0f0f0",
  };
  const navbarLogoStyle = {
    display: "flex",
    alignItems: "center",
    gap: "10px", // Adjust spacing between logo and text
  };
  
  const logoStyle = {
    marginTop:"10px",
    height: "150px", // Adjust size based on your navbar height
    width: "auto", // Maintain aspect ratio
  };
  
  // const logoTextStyle = {
  //   fontSize: "22px", // Adjust size for proper fit
  //   fontWeight: "bold",
  //   fontstyle: "italic",
  //   color: "#0b023d", // Adjust color as needed
  //   background: "linear-gradient(90deg,rgb(113, 60, 4),rgb(190, 192, 199),rgb(4, 52, 27))", // Gradient colors
  //   WebkitBackgroundClip: "text",
  //   WebkitTextFillColor: "transparent",
  // };
 
  return (
    <nav className="navbar">
      {/* Logo */}
      <div style={navbarLogoStyle}>
  <img src={logo} alt="Voter Logo" style={logoStyle} />
  {/* <span style={logoTextStyle}>Karyalay</span> */}
</div>


      {/* Center Navigation Links */}
      <ul className="navbar-links">
        <li>
          <a href="#home" onClick={() => handleScroll("home")}>
            <FaHome /> Home
          </a>
        </li>
        <li>
          <a href="#about" onClick={() => handleScroll("about")}>
            <FaInfoCircle /> About Us
          </a>
        </li>
        <li>
          <a href="#contact" onClick={() => handleScroll("contact")}>
            <FaPhoneAlt /> Contact
          </a>
        </li>
        <li>
          <a href="#social" onClick={() => handleScroll("contact")}>
            <FaUsers /> Social
          </a>
        </li>
        <li>
         {/* <a
            onClick={() => {
              navigate("/appointment");
            }}
          >
           <FaSignOutAlt /> Appointment
          </a> */}
          <a onClick={() => navigate("/feedback")}>
            <FaSignOutAlt /> Feedback
          </a>
        </li>
      </ul>

      {/* Right Side Buttons */}
      <div className="navbar-right">
        {/* Login Button */}
        <button className="login-button"
        onClick={() => {
          navigate("/signin");
        }}
        >
          Login <FiArrowUpRight className="arrow-icon" />
        </button>

        {/* Search Icon */}
        {/* <button className="icon-button">
          <FiSearch />
        </button> */}

        {/* Menu Icon */}
        <button 
        className="icon-button" 
        onClick={() => setIsOpen(!isOpen)}
       
      >
        <HiOutlineMenuAlt3 />
      </button>

      {/* Dropdown Menu */}
      {/* {isOpen && (
        <div style={menuStyle}>
        <ul style={menuListStyle}>
          <li style={menuItemStyle} onClick={() => handleScroll("home")}><FaHome /> Home</li>
          <li  style={menuItemStyle} onClick={() => handleScroll("about")}><FaInfoCircle /> About Us</li>
          <li style={menuItemStyle} onClick={() => handleScroll("contact")}><FaPhoneAlt /> Contact</li>
          <li style={menuItemStyle} onClick={() => handleScroll("social")}><FaUsers /> Social</li>
          <li  style={menuItemStyle} className="logout"><FaSignOutAlt /> Logout</li>
        </ul>
      </div>
      )} */}
    
      </div>
    </nav>
  );
}

export default Navbar;





